import { StringUtil, AppService, AppConfig } from '@aperza/util';
import Cookie from 'js-cookie';
import Treasure from 'td-js-sdk';
const appConfig = AppService.appConfig();
let database = 'dev';
if (appConfig.env === AppConfig.ENV_STG) {
    database = 'stg';
}
else if (appConfig.env === AppConfig.ENV_PROD) {
    database = 'biz';
}
const tdService = new Treasure({
    host: 'in.treasuredata.com',
    database,
    writeKey: '6090/46967b7d631fed017bff903190f8a5db1f3971b5',
});
// Enable cross-domain tracking
tdService.set('$global', 'td_global_id', 'td_global_id');
export default class TdWebService {
    static setMemberId(memberId) {
        TdWebService._memberId = memberId;
    }
    static testLibrary() {
        console.log('This is inside the library');
    }
    static trackPageview() {
        TdWebService._tdService.trackPageview('pageviews');
    }
    static search(id, searchQuery, url) {
        return new Promise((resolve, reject) => {
            TdWebService._tdService.set('$global', 'td_global_id', 'td_global_id');
            TdWebService._tdService.trackEvent('aperza_web', {
                event: 2,
                parts: id,
                search_query: searchQuery,
                ubid: TdWebService.getUbidCookie(),
                rd_ubid: TdWebService.getRDUbidCookie(),
                member_id: TdWebService._memberId,
            });
            return resolve();
        });
    }
    static userMenu(id, url, anchorText) {
        return new Promise((resolve, reject) => {
            TdWebService._tdService.set('$global', 'td_global_id', 'td_global_id');
            TdWebService._tdService.trackEvent('aperza_web', {
                event: 2,
                parts: 'td-parts-reactroot',
                action: id,
                click_url: url,
                anchor_text: anchorText,
                ubid: TdWebService.getUbidCookie(),
                rd_ubid: TdWebService.getRDUbidCookie(),
                member_id: TdWebService._memberId,
            });
            return resolve();
        });
    }
    static cluez(path, cluezUser) {
        return new Promise((resolve, reject) => {
            TdWebService._tdService.set('$global', 'td_global_id', 'td_global_id');
            TdWebService._tdService.trackEvent('cluez_data', {
                td_path: path,
                id_member_area_id: cluezUser.addressLargeAreaId,
                id_member_status_code: cluezUser.statusCode,
                id_member_country_code: StringUtil.toUpper(cluezUser.countryCode),
                side_code: 'jp',
                lang_code: cluezUser.locale,
                ubid: TdWebService.getUbidCookie(),
                rd_ubid: TdWebService.getRDUbidCookie(),
                id_member: TdWebService._memberId,
            });
            return resolve();
        });
    }
    /**
     * _ubidクッキー情報(uuid)を取得。存在しない場合は生成する。
     */
    static getUbidCookie() {
        return Cookie.get('_ubid');
    }
    static getRDUbidCookie() {
        return Cookie.get('__ubid');
    }
}
TdWebService._tdService = tdService;
export { TdWebService };
